import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from './Logo';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  const scrollToForm = () => {
    document.getElementById('formulario')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex flex-col items-center justify-center bg-hero-gradient overflow-hidden pt-20 px-6" data-id="element-183">
      {/* Floating Gold Particles */}
      {[...Array(15)].map((_, i) => <motion.div key={i} className="absolute w-1.5 h-1.5 bg-champagne-gold rounded-full opacity-40" initial={{
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight
    }} animate={{
      y: [null, Math.random() * -100 - 50],
      opacity: [0.2, 0.6, 0.2]
    }} transition={{
      duration: Math.random() * 5 + 5,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-184" />)}

      <div className="relative z-10 flex flex-col items-center text-center max-w-4xl mx-auto mt-10" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-186">
          <Logo className="w-[70px] h-[70px] md:w-[100px] md:h-[100px] mb-6" data-id="element-187" />
          <div className="w-[60px] h-[2px] bg-champagne-gold mb-8" data-id="element-188"></div>

          <span className="text-champagne-gold font-montserrat font-semibold text-sm tracking-[0.2em] uppercase mb-6" data-id="element-189">
            Comunidad de Mujeres Transformadas
          </span>

          <h1 className="font-playfair font-bold text-white text-4xl md:text-[58px] leading-[1.2] mb-8" data-id="element-190">
            Tu Historia Tiene
            <br data-id="element-191" />
            el Poder de Cambiar
            <br data-id="element-192" />
            la Vida de Otra Mujer
          </h1>

          <p className="font-montserrat text-white/85 text-lg md:text-xl max-w-[600px] mb-12 leading-relaxed" data-id="element-193">
            Tu experiencia puede ser exactamente lo que otra mujer de 40+
            necesita leer hoy para dar su primer paso hacia recuperar su cuerpo,
            su energía y su confianza.
          </p>

          <div className="w-[120px] h-[2px] bg-champagne-gold mb-12" data-id="element-194"></div>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={scrollToForm} className="bg-cta-gradient text-white font-montserrat font-bold text-lg py-5 px-10 rounded-full shadow-cta-shadow hover:shadow-cta-shadow-hover transition-all duration-300 mb-6" data-id="element-195">
            Quiero Compartir Mi Historia 💙
          </motion.button>

          <p className="font-cormorant italic text-white/60 text-lg" data-id="element-196">
            Gratuito • Sin compromiso • Solo tu voz y tu experiencia
          </p>
        </motion.div>
      </div>

      <motion.div className="absolute bottom-10 flex flex-col items-center gap-2" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} data-id="element-197">
        <span className="text-champagne-gold font-montserrat text-sm" data-id="element-198">
          Descubre por qué tu historia importa
        </span>
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-199">
          <ChevronDown className="text-champagne-gold w-6 h-6" data-id="element-200" />
        </motion.div>
      </motion.div>
    </section>;
}